import { CTAProps } from '@/components/CTA';
import { CTABlock } from '@/components/blocks/CTABlock/CTABlock';
import React from 'react';
import styles from './BrandsContent.module.scss';

export interface BrandLogoProps {
  src: string;
  alt?: string;
}

export interface BrandsContentProps {
  brands: BrandLogoProps[];
  ctas?: CTAProps[];
  caption?: string;
}

export const BrandsContent: React.FC<BrandsContentProps> = ({ brands, caption, ctas }) => {
  return (
    <div className={styles.brands_content}>
      <div className={styles.brands_flex_container}>
        {brands.map((brand, idx) => (
          // eslint-disable-next-line @next/next/no-img-element
          <img key={idx} src=/mlp-cms/_next/static/chunks/{brand.src} alt={brand.alt || 'Brand Logo'} loading="lazy" />
        ))}
      </div>
      {ctas && <CTABlock ctas={ctas} caption={caption} className={styles.cta_block} />}
    </div>
  );
};
